import FormInstance from "../models/serviceModels/FormInstance";
import { isValidEmail } from "./validation/emailValidation";

const buildPublicSubmissionFollowUpLink = (token: string): string => {
    const appBaseUrl = (process.env.REACT_APP_APP_BASE_URL || window.location.origin).replace(/\/$/, '');
    return `${appBaseUrl}/forms/public/submissions/follow-up/${encodeURIComponent(token)}`;
};

const getPublicSubmissionParticipantEmail = (instance?: FormInstance): string => {
    const email = instance?.instanceFields.find(field => field.name === 'main_profile_email')?.value?.trim() || '';
    return isValidEmail(email) ? email : '';
};

const buildPublicSubmissionFollowUpMailto = (email: string, formName: string, link: string): string => {
    const subject = `Additional documentation requested - ${formName}`;
    const body = [
        'Additional documentation has been requested for your submission.',
        '',
        'Use the secure link below to respond:',
        link
    ].join('\r\n');
    const query = new URLSearchParams({ subject, body });
    return `mailto:${encodeURIComponent(isValidEmail(email) ? email.trim() : '')}?${query.toString()}`;
};

export {
    buildPublicSubmissionFollowUpLink,
    buildPublicSubmissionFollowUpMailto,
    getPublicSubmissionParticipantEmail
};
